import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';
import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const getAllWalletAddress = createAsyncThunk(
  'member/wallet-address/list',
  async ({ page, search, limit, dispatch }) => {
    try {
      const response = await get(
        `/member/wallet-address?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const createWalletAddress = createAsyncThunk(
  'member/wallet-address/new',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/member/wallet-address/new `;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getWalletAddressDetails = createAsyncThunk(
  'member/wallet-address/single',
  async ({ walletId, dispatch }) => {
    try {
      console.log('ID:', walletId);
      const response = await get(`/member/wallet-address/${walletId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const updateWalletAddressDetails = createAsyncThunk(
  'member/wallet-address/update',
  async ({ state, walletId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/member/wallet-address/${walletId}`;
      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        if (handleClear) {
          handleClear();
        }
        const credentials = {
          page: 1,
          search: '',
          limit: 10,
          dispatch,
        };
        dispatch(getAllWalletAddress(credentials));
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteWalletAddress = createAsyncThunk(
  'member/wallet-address/delete',
  async ({ walletId, dispatch }) => {
    try {
      const response = await del(`/member/wallet-address/${walletId}`);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address deleted Successfully' }));
        const credentials = {
          page: 1,
          search: '',
          limit: 10,
          dispatch,
        };
        dispatch(getAllWalletAddress(credentials));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllWalletAddressAdmin = createAsyncThunk(
  'admin/wallet-address/list',
  async ({ page, search, limit, dispatch, id }) => {
    try {
      const response = await get(
        `/member/admin/wallet-address/${id}?page=${page && page}&search=${search && search}&limit=${
          limit || 5
        }`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      console.log('error =>', error);
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const createWalletAddressAdmin = createAsyncThunk(
  'admin/wallet-address/new',
  async ({ state, dispatch, handleClose, handleClear, id }) => {
    try {
      const URL = `/member/admin/wallet-address/new/${id} `;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getWalletAddressDetailsAdmin = createAsyncThunk(
  'admin/wallet-address/single',
  async ({ walletId, dispatch }) => {
    try {
      console.log('ID:', walletId);
      const response = await get(`/member/admin/wallet-address/${walletId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const updateWalletAddressDetailsAdmin = createAsyncThunk(
  'admin/wallet-address/update',
  async ({ state, walletId, dispatch, handleClose, handleClear, id }) => {
    try {
      const URL = `/member/admin/wallet-address/${walletId}/${id}`;
      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        if (handleClear) {
          handleClear();
        }
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteWalletAddressAdmin = createAsyncThunk(
  'admin/wallet-address/delete',
  async ({ walletId, id, dispatch }) => {
    try {
      const response = await del(`/member/admin/wallet-address/${walletId}/${id}`);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Wallet Address deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const walletAddressSlice = createSlice({
  name: 'wallet address',
  initialState: {
    loading: false,
    error: {},
    walletAddresses: {},
    walletAddressDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllWalletAddress.pending]: (state) => {
      state.loading = true;
    },
    [getAllWalletAddress.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletAddresses = action.payload;
      state.error = {};
    },
    [getAllWalletAddress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // create  details
    [createWalletAddress.pending]: (state) => {
      state.loading = true;
    },
    // [createWalletAddress.fulfilled]: (state, action) => {
    //   const jsonState = covertToJSON(state)?.walletAddresses;
    //   console.log('json state:', jsonState);
    //   console.log('payload:', action.payload);

    //   const newList = jsonState?.walletAddresses;

    //   const modifiedList = {
    //     ...jsonState,
    //     walletAddresses: Array.isArray(newList) ? [...newList, action.payload] : [action.payload],
    //   };
    //   state.loading = false;
    //   state.walletAddressDetails = action.payload;
    //   state.walletAddresses = modifiedList;
    //   state.error = {};
    // },

    [createWalletAddress.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;
      const newCityList = jsonState?.walletAddresses;

      const modifiedCityList = {
        ...jsonState,
        walletAddresses: Array.isArray(newCityList)
          ? [action.payload, ...newCityList]
          : [action.payload],
      };
      state.loading = false;
      state.walletAddressDetails = action.payload;
      state.walletAddresses = modifiedCityList;
      state.error = {};
    },
    [createWalletAddress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getWalletAddressDetails.pending]: (state) => {
      state.loading = true;
    },
    [getWalletAddressDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletAddressDetails = action.payload;
      state.error = {};
    },
    [getWalletAddressDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [updateWalletAddressDetails.pending]: (state) => {
      state.loading = true;
    },

    // [updateWalletAddressDetails.fulfilled]: (state, action) => {
    //   const jsonState = covertToJSON(state)?.walletAddresses;
    //   console.log('payload', action.payload);
    //   const modifiedList = {
    //     ...jsonState,
    //     walletAddresses: jsonState.walletAddresses?.map((i) =>
    //       i._id === action.payload._id ? action?.payload : i
    //     ),
    //   };

    //   state.loading = false;
    //   // state.walletAddresses = modifiedList;
    //   state.walletAddressDetails = action.payload;
    //   state.walletAddresses = modifiedList;
    //   state.error = {};
    // },

    [updateWalletAddressDetails.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;
      const modifiedList = {
        ...jsonState,
        walletAddresses: jsonState?.walletAddresses.map((i) =>
          i._id === action.payload._id ? action?.payload : i
        ),
      };
      state.loading = false;
      state.walletAddressDetails = action.payload;
      state.walletAddresses = modifiedList;
      state.error = {};
    },
    [updateWalletAddressDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteWalletAddress.pending]: (state) => {
      state.loading = true;
    },
    // [deleteWalletAddress.fulfilled]: (state, action) => {
    //   const jsonState = covertToJSON(state)?.walletAddresses;
    //   const modifiedList = {
    //     ...jsonState,
    //     walletAddresses: jsonState.walletAddresses?.filter(
    //       (schoolDivisions) => schoolDivisions._id !== action.payload
    //     ),
    //   };

    //   state.loading = false;
    //   state.walletAddresses = modifiedList;
    //   state.error = {};
    // },
    [deleteWalletAddress.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;
      console.log('jason', jsonState);
      console.log('payload', action.payload);
      const modifiedList = {
        ...jsonState,
        walletAddresses: jsonState.walletAddresses?.filter(
          (walletAddress) => walletAddress._id !== action.payload
        ),
      };

      state.loading = false;
      state.walletAddresses = modifiedList;
      state.error = {};
    },
    [deleteWalletAddress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // admin wallet Address

    [getAllWalletAddressAdmin.pending]: (state) => {
      state.loading = true;
    },
    [getAllWalletAddressAdmin.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletAddresses = action.payload;
      state.error = {};
    },
    [getAllWalletAddressAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // create  details
    [createWalletAddressAdmin.pending]: (state) => {
      state.loading = true;
    },
    [createWalletAddressAdmin.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;
      console.log(jsonState);
      console.log(action.payload);
      const newList = jsonState?.wallet_address;
      console.log(newList);
      const modifiedList = {
        ...jsonState,
        walletAddresses: newList ? [action?.payload, ...newList] : [action.payload],
      };

      console.log(modifiedList);
      state.loading = false;
      state.walletAddresses.wallet_address = modifiedList?.walletAddresses;
      state.error = {};
    },
    [createWalletAddressAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getWalletAddressDetailsAdmin.pending]: (state) => {
      state.loading = true;
    },
    [getWalletAddressDetailsAdmin.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletAddressDetails = action.payload;
      state.error = {};
    },
    [getWalletAddressDetailsAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [updateWalletAddressDetailsAdmin.pending]: (state) => {
      state.loading = true;
    },

    [updateWalletAddressDetailsAdmin.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;
      console.log(jsonState);
      const updateNewList = jsonState?.wallet_address;
      const modifiedList = {
        ...updateNewList,
        walletAddresses: updateNewList?.map((i) =>
          i._id === action.payload._id ? action?.payload : i
        ),
      };
      console.log(modifiedList);
      state.loading = false;
      // state.walletAddresses = modifiedList;
      state.walletAddressDetails = action.payload;
      state.walletAddresses.wallet_address = modifiedList?.walletAddresses;
      state.error = {};
    },

    [updateWalletAddressDetailsAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteWalletAddressAdmin.pending]: (state) => {
      state.loading = true;
    },
    // [deleteWalletAddressAdmin.fulfilled]: (state, action) => {
    //   const jsonState = covertToJSON(state)?.walletAddresses;
    //   const modifiedList = {
    //     ...jsonState,
    //     walletAddresses: jsonState.walletAddresses?.filter(
    //       (schoolDivisions) => schoolDivisions._id !== action.payload
    //     ),
    //   };

    //   state.loading = false;
    //   state.walletAddresses = modifiedList;
    //   state.error = {};
    // },
    [deleteWalletAddressAdmin.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletAddresses;

      console.log(jsonState);
      console.log(action.payload);
      const modifiedList = {
        ...jsonState,
        walletAddresses: jsonState.wallet_address?.filter(
          (walletAddresses) => walletAddresses._id !== action.payload
        ),
      };
      state.loading = false;
      console.log(modifiedList);
      state.walletAddresses.wallet_address = modifiedList?.walletAddresses;
      state.error = {};
    },
    [deleteWalletAddressAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = walletAddressSlice.actions;

export default walletAddressSlice.reducer;
